import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"

const SnapchatIconSvg = ({
  color = "primary",
  bg = "#f5f9f9",
  iconStyle,
  ...rest
}) => {
  return (
    <Svg
      fill="none"
      height="33"
      viewBox="-5.3 0 28 16"
      width="33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="m16.8664 13.0524c-2.8405-1.353-3.2932-3.44208-3.3133-3.59703-.0244-.18769-.052-.33526.1584-.52618.2029-.18447 1.1032-.73279 1.353-.90434.4128-.28407.5947-.56769.4606-.91632-.0937-.24119-.3219-.33204-.5623-.33204-.0759.00023-.1515.00858-.2255.0249-.4536.09685-.8941.32051-1.1491.38092-.0306.00777-.0621.01195-.0937.01245-.1359 0-.1875-.05949-.1743-.22043.0318-.48791.0993-1.4402.0211-2.32978-.1074-1.22392-.5085-1.83035-.9842-2.36667-.2301-.2601-1.2986-1.377489-3.36063-1.377489s-3.12912 1.117389-3.35782 1.374259c-.47708.53633-.87777 1.14275-.98415 2.36667-.07826.88958-.00797 1.84141.02109 2.32978.00937.15311-.03843.22044-.17434.22044-.03163-.00054-.06309-.00472-.09373-.01246-.25447-.06041-.69499-.28407-1.14864-.38091-.074-.01633-.14958-.02468-.22542-.02491-.24135 0-.46864.09224-.56237.33204-.13403.34864.04687.63225.46115.91632.24978.17156 1.15005.71941 1.35297.90434.20995.19092.18277.33849.1584.52618-.02015.15726-.47333 2.24636-3.3133 3.59706-.166371.0793-.449432.2472.04967.5183.78357.4261 1.30517.3805 1.71055.6374.34398.2181.14059.6885.39085.8582.30743.2089 1.21612-.0148 2.39007.3666.98415.3191 1.58214 1.2207 3.32736 1.2207 1.74519 0 2.36059-.9057 3.32739-1.2207 1.1716-.3814 2.0822-.1577 2.3901-.3666.2497-.1697.0468-.6401.3908-.8582.4054-.2569.9265-.2113 1.7105-.6374.4982-.2679.2152-.4358.0488-.5151z"
        fill={color}
      />
    </Svg>
  )
}

export default SnapchatIconSvg
